import { createRouter, createMemoryHistory } from "vue-router";

/**
 * Vue 메모리 라우터 팩토리.
 * VueAppBridge의 useEffect 초기화 시 단 한 번만 호출한다.
 * 브라우저 URL은 React Router가 관리하며 이 라우터는 메모리 전용이다.
 */
export function createVueRouter() {
  return createRouter({
    history: createMemoryHistory(),
    routes: [
      {
        path: "/",
        name: "root",
        component: () => import("../views/HomeView.vue"),
      },
      {
        path: "/solver",
        name: "solver",
        component: () => import("../views/SolverView.vue"),
      },
      {
        path: "/results",
        name: "results",
        component: () => import("../views/ResultsView.vue"),
      },
      {
        path: "/results/c/:configHash",
        name: "results-cached",
        component: () => import("../views/ResultsView.vue"),
      },
      {
        path: "/history",
        name: "history",
        component: () => import("../views/HistoryView.vue"),
      },
      {
        path: "/preflop-solutions",
        name: "preflop-solutions",
        component: () => import("../views/PreflopSolutionsView.vue"),
        props: { terminalPostflopModel: "lightweight_postflop_solve" },
      },
      {
        path: "/easy-preflop-solutions",
        name: "easy-preflop-solutions",
        component: () => import("../views/PreflopSolutionsView.vue"),
        props: { terminalPostflopModel: "lightweight_postflop_solve" },
      },
      {
        path: "/preflop-trace",
        name: "preflop-trace",
        component: () => import("../views/PreflopTraceExplorerBannerView.vue"),
      },
      {
        path: "/preflop-trace-2",
        name: "preflop-trace-2",
        redirect: (to) => ({
          path: "/preflop-trace",
          query: to.query,
          hash: to.hash,
        }),
      },
      {
        path: "/ai-setup",
        name: "ai-setup",
        component: () => import("../views/AiSetupView.vue"),
      },
      {
        path: "/image-relay/connect",
        name: "image-relay-connect",
        component: () => import("../views/ImageRelayConnectView.vue"),
      },
      // React 네이티브 페이지 (Vue에서는 도달하지 않는 라우트):
      // VueBridgeLayout 이 /settings, /documents/* 를 navView="home" 으로 매핑하므로
      // VueAppBridge 는 Vue router 를 "/" 로 replace 한다. 이 라우트들은 실제로 도달하지 않는다.
      // React Outlet 이 실제 SettingsPage/DocumentsIndexPage 등을 렌더링한다.
      //
      // `/:pathMatch(.*)*` fallback 이 있어도 명시 등록하는 이유:
      // 의도를 코드로 표현해 미래 독자가 "왜 이 경로가 Vue 라우터에 없는지" 혼란을 겪지 않게 한다.
      // 마이그레이션이 완료되어 Vue 레이어가 제거될 때 이 라우트들도 함께 제거해야 한다 —
      // Vue 라우터가 React 컨텍스트(`/documents` 등) 를 아는 약한 역방향 결합이므로.
      {
        path: "/settings",
        name: "settings",
        component: () => import("../views/HomeView.vue"),
      },
      {
        path: "/range-explorer",
        name: "range-explorer",
        component: () => import("../views/HomeView.vue"),
      },
      {
        // `:slug?` 선택적 매개변수로 `/documents` 자체와 `/documents/<slug>` 둘 다 매칭.
        // fallback 보다 먼저 선언되어 Vue 라우터의 unknown-path 경고를 막는 안전망.
        path: "/documents/:slug?",
        name: "documents",
        component: () => import("../views/HomeView.vue"),
      },
      {
        path: "/:pathMatch(.*)*",
        name: "fallback",
        component: () => import("../views/HomeView.vue"),
      },
    ],
  });
}
